import React from 'react';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import IconButton from 'ui/IconButton';
import IconArrowLeft from 'ui/icons/ArrowLeft';
import IconArrowRight from 'ui/icons/ArrowRight';
import { MONTHS } from 'toolkit/constants';

import { RenderHeaderMode } from './types';

import styles from './index.module.scss';

export const renderDateInputHeader =
  (mode: RenderHeaderMode, isMobile: boolean = false) =>
  ({
    monthDate,
    decreaseMonth,
    increaseMonth,
    customHeaderCount,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }: ReactDatePickerCustomHeaderProps) => {
    const prevBtnAvailable =
      !isMobile && (customHeaderCount === 0 || mode === RenderHeaderMode.SINGLE) && !prevMonthButtonDisabled;

    const nextBtnAvailable =
      !isMobile && (customHeaderCount === 1 || mode === RenderHeaderMode.SINGLE) && !nextMonthButtonDisabled;

    return (
      <div className={styles.DatePickerHeader}>
        <IconButton
          onClick={decreaseMonth}
          className={prevBtnAvailable ? styles.DatePickerHeaderButton : styles.DatePickerHeaderButtonDisabled}
          elementId="date-picker-header-back-button">
          <IconArrowLeft />
        </IconButton>

        <h4>
          {MONTHS[monthDate.getMonth()]}
          &nbsp;
          {monthDate.getFullYear()}
        </h4>

        <IconButton
          onClick={increaseMonth}
          className={nextBtnAvailable ? styles.DatePickerHeaderButton : styles.DatePickerHeaderButtonDisabled}
          elementId="date-picker-header-forward-button">
          <IconArrowRight />
        </IconButton>
      </div>
    );
  };
